// SIDE BY SIDE, NOT ON TOP OF EACH OTHER. Two partners can hold meetings at the same
// hour — that is the whole point of per-partner diaries — so a day column has to place
// concurrent meetings beside one another rather than stacking them and hiding one.
//
// The rule is the standard greedy lane assignment: walk the day in start order and drop
// each meeting into the first lane whose last meeting has already finished. Meetings that
// do not overlap share a lane and stay full width; only the ones that genuinely collide
// are narrowed, so an ordinary day is not squeezed because one hour is busy.
//
// Half-open intervals here too, matching the server: a meeting starting exactly when
// another ends does NOT overlap it and reuses its lane (server/utils/time.js).
import { minutesOf } from './calendarDates';

export const layoutDay = (meetings) => {
  const sorted = [...meetings].sort((a, b) => {
    const d = minutesOf(a.start_time) - minutesOf(b.start_time);
    return d !== 0 ? d : minutesOf(a.end_time) - minutesOf(b.end_time);
  });

  const laneEnds = [];   // the end minute of the last meeting placed in each lane
  const placed = sorted.map((m) => {
    const start = minutesOf(m.start_time);
    const end = minutesOf(m.end_time);
    let lane = laneEnds.findIndex((laneEnd) => laneEnd <= start);
    if (lane === -1) { lane = laneEnds.length; laneEnds.push(end); }
    else laneEnds[lane] = end;
    return { meeting: m, start, end, lane };
  });

  // How many lanes each meeting must actually share its width with. Using the day's total
  // lane count would narrow every meeting because of one busy hour; a meeting is only
  // narrowed by the ones it truly overlaps.
  return placed.map((p) => {
    const concurrent = placed.filter((q) => p.start < q.end && q.start < p.end);
    const lanes = Math.max(...concurrent.map((q) => q.lane)) + 1;
    return { ...p, lanes };
  });
};
